import { ROUTE_PLASMIDS } from "../../routes";

export const correctPlasmidName = (data) => data.plasmidName;

export const routeSet = (setID) => `${ROUTE_PLASMIDS}/${setID}`;
export const routePlasmid = (setID, plasmidID) =>
	`${ROUTE_PLASMIDS}/${setID}/${plasmidID}`;
